module.exports = __webpack_public_path__ + "static/media/event.972b7c40.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/event.svg
// module id = 92
// module chunks = 0